export default {
    items: [
        {value: 1, label: 'Одноразовый'},
        {value: 2, label: 'Многоразовый'},
    ]
}